import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export type NotificationStatus = "UNSEEN" | "SEEN" | "READ" | "LOCKED" | "CLEARED" | "DELETED" | "EXPIRED";

export type NotificationSeverity = "CRITICAL" | "HIGH" | "MEDIUM" | "LOW" | "INFO";

export type NotificationCategory = "CLOUD_ALERT" | "SYSTEM" | "VERSION_UPDATE" | "GENERAL" | "RESOURCE_REQUEST";

export type AdminSettableStatus = "UNSEEN" | "SEEN" | "READ" | "LOCKED" | "DELETED";

export interface AdminNotification {
  id: string;
  title: string;
  details?: string | null;
  severity?: NotificationSeverity | null;
  category: NotificationCategory;
  status: NotificationStatus;
  tenantName?: string | null;
  cloudAccountId?: string | null;
  cloudType?: "AWS" | "AZURE" | "GCP" | null;
  alertId?: string | null;
  actionUrl?: string | null;
  metadata?: Record<string, string> | null;
  createdAt: string;
  expiresAt?: string | null;
}

export interface AdminNotificationFeed {
  notifications: AdminNotification[];
  unseenCount: number;
  unreadCount: number;
  serverTime: string;
}

const BASE_URL = `${NGROK}/api/admin-notifications`;

export const fetchAdminNotifications = (tenantName: string, signal?: AbortSignal) =>
  apiClient<AdminNotificationFeed>({
    method: "GET",
    url: BASE_URL,
    params: tenantName ? { tenantName } : undefined,
    signal,
  });

export const markAdminNotificationsSeen = (tenantName: string, uuids: string[]) =>
  apiClient<{ updated: number }>({
    method: "POST",
    url: `${BASE_URL}/seen`,
    data: { tenantName, uuids },
  });

export const updateAdminNotificationStatus = (
  uuid: string,
  tenantName: string,
  status: AdminSettableStatus,
) =>
  apiClient<AdminNotification>({
    method: "PATCH",
    url: `${BASE_URL}/${encodeURIComponent(uuid)}/status`,
    data: { tenantName, status },
  });

export const clearAdminNotifications = (tenantName: string) =>
  apiClient<{ cleared: number }>({
    method: "POST",
    url: `${BASE_URL}/clear`,
    params: tenantName ? { tenantName } : undefined,
  });

export const markAllAdminNotificationsRead = (tenantName: string) =>
  apiClient<{ updated: number }>({
    method: "POST",
    url: `${BASE_URL}/read-all`,
    params: tenantName ? { tenantName } : undefined,
  });
